import { AxiosInstance } from "axios";

/** The phone platforms Expo push tokens come from. */
export type PushDevicePlatform = "ios" | "android";

/**
 * Push device endpoints: a phone registering its Expo push token for the signed-in user.
 * Platform-agnostic - works with any HTTP client
 */
export class PushDevicesApi {
  constructor(private client: AxiosInstance) {}

  /**
   * Register this phone's Expo push token for the signed-in user. A token another account held
   * moves to this one.
   */
  async register(token: string, platform: PushDevicePlatform): Promise<void> {
    await this.client.post("/api/pushdevices", { token, platform });
  }

  /** Stop sending to this phone's token. Call before the access token is dropped on sign-out. */
  async unregister(token: string): Promise<void> {
    await this.client.post("/api/pushdevices/unregister", { token });
  }
}
